// extracted by mini-css-extract-plugin
export default {"content":"Modal_content__KDPPi","modal":"Modal_modal__lBw2D","closeButton":"Modal_closeButton__2Y7zn"};